import {CloseCircleOutlined as AntdCloseCircleOutlined} from '@ant-design/icons';

export default function CloseCircleOutlined(props) {
  return <AntdCloseCircleOutlined {...props} />;
}
